import React from "react";
import { motion } from "framer-motion";
import { THEME } from "./theme";

// The mobile flow's "What data would you like to enter?" cards: one row per
// category (Feed / Mortality / Weight) showing the value already recorded for
// the selected day, or "Not entered", with an Add/Edit chip. Tapping a row
// opens the value-entry panel for that category.

const listContainer = { hidden: {}, visible: { transition: { staggerChildren: 0.05 } } };
const listItem = { hidden: { opacity: 0, x: -12 }, visible: { opacity: 1, x: 0 } };

const CategoryCards = ({ actions, isEntered, summaryFor, t, onPick }) => (
  <motion.div variants={listContainer} initial="hidden" animate="visible">
    {actions.map(({ value, Icon }) => {
      const entered = isEntered(value);
      const current = entered ? summaryFor(value) : "";
      return (
        <motion.button
          key={value}
          type="button"
          variants={listItem}
          whileHover={{ scale: 1.015 }}
          whileTap={{ scale: 0.985 }}
          onClick={() => onPick(value)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            width: "100%",
            textAlign: "left",
            background: "#fff",
            border: `1px solid ${entered ? "#e2e8f0" : "#bfdbfe"}`,
            borderRadius: 12,
            padding: "10px 13px",
            marginBottom: 8,
            cursor: "pointer",
            boxShadow: "0 1px 2px rgba(15,23,42,0.04)",
          }}
        >
          <span
            style={{
              flexShrink: 0,
              width: 34,
              height: 34,
              borderRadius: "50%",
              background: entered ? "#dcfce7" : THEME.soft,
              color: entered ? THEME.green : THEME.blue,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon size={15} />
          </span>
          <span style={{ flex: 1 }}>
            <span style={{ display: "block", fontSize: 14, fontWeight: 600, color: THEME.ink }}>
              {t.actions[value]}
            </span>
            <span style={{ fontSize: 11.5, color: entered ? THEME.green : THEME.grey }}>
              {entered
                ? `✓ ${t.statusEntered}${current !== "" ? ` · ${current}` : ""}`
                : t.statusPending}
            </span>
          </span>
          <span
            style={{
              flexShrink: 0,
              fontSize: 11.5,
              fontWeight: 700,
              color: "#fff",
              background: entered ? THEME.grey : THEME.blue,
              borderRadius: 12,
              padding: "4px 10px",
            }}
          >
            {entered ? t.edit : t.add}
          </span>
        </motion.button>
      );
    })}
  </motion.div>
);

export default CategoryCards;
